module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "required": "",
      "label": "Nome"
    },
    model: {
      value: (_vm.empresa.nome),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "nome", $$v)
      },
      expression: "empresa.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cnpj",
      "required": "",
      "label": "CNPJ"
    },
    model: {
      value: (_vm.empresa.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "cnpj", $$v)
      },
      expression: "empresa.cnpj"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nomeFantasia",
      "required": "",
      "label": "Nome Fantasia"
    },
    model: {
      value: (_vm.empresa.nomeFantasia),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "nomeFantasia", $$v)
      },
      expression: "empresa.nomeFantasia"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "idSistema",
      "label": "ID Sistema"
    },
    model: {
      value: (_vm.empresa.idSistema),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "idSistema", $$v)
      },
      expression: "empresa.idSistema"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "intervaloStorage",
      "required": "",
      "label": "Storage"
    },
    model: {
      value: (_vm.empresa.intervaloStorage),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "intervaloStorage", $$v)
      },
      expression: "empresa.intervaloStorage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "color",
      "name": "cor",
      "label": "Cor"
    },
    model: {
      value: (_vm.empresa.cor),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "cor", $$v)
      },
      expression: "empresa.cor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "site",
      "label": "Site"
    },
    model: {
      value: (_vm.empresa.site),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "site", $$v)
      },
      expression: "empresa.site"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email"
    },
    model: {
      value: (_vm.empresa.email),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "email", $$v)
      },
      expression: "empresa.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "textoRodape",
      "label": "Texto Rodapé"
    },
    model: {
      value: (_vm.empresa.textoRodape),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "textoRodape", $$v)
      },
      expression: "empresa.textoRodape"
    }
  })], 1)], 1), _vm._v(" "), (_vm.empresa.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "label": "Logo"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus($event)
      }
    },
    model: {
      value: (_vm.empresa.logoUrl),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "logoUrl", $$v)
      },
      expression: "empresa.logoUrl"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file2",
      "single-line": "",
      "label": "Carimbo"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus2($event)
      }
    },
    model: {
      value: (_vm.empresa.carimboUrl),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "carimboUrl", $$v)
      },
      expression: "empresa.carimboUrl"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput2",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ativo",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.ativa),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "ativa", $$v)
      },
      expression: "empresa.ativa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Assinar Exames",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.assinatura),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "assinatura", $$v)
      },
      expression: "empresa.assinatura"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Remover Documento Assinatura",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.removerDocumentoAssinatura),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "removerDocumentoAssinatura", $$v)
      },
      expression: "empresa.removerDocumentoAssinatura"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Impressão de Imagens",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.impressao),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "impressao", $$v)
      },
      expression: "empresa.impressao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Whatsapp",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.whatsapp),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "whatsapp", $$v)
      },
      expression: "empresa.whatsapp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Pesquisa Satisfação",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.pesquisa),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "pesquisa", $$v)
      },
      expression: "empresa.pesquisa"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Envio automático",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.envioAutomaticoResultado),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "envioAutomaticoResultado", $$v)
      },
      expression: "empresa.envioAutomaticoResultado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Adicionar QRCode",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.qrcode),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "qrcode", $$v)
      },
      expression: "empresa.qrcode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "label": "Modelo QR Code",
      "items": _vm.modeloQRcodes,
      "item-text": "descricao",
      "item-value": "id",
      "max-height": "400",
      "hint": "Selecione o modelo de QRCode",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.empresa.modeloQRcode),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "modeloQRcode", $$v)
      },
      expression: "empresa.modeloQRcode"
    }
  })], 1)], 1), _vm._v(" "), (_vm.empresa.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "tamanhoQr",
      "label": "Tamanho QRCode"
    },
    model: {
      value: (_vm.empresa.tamanhoQr),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "tamanhoQr", $$v)
      },
      expression: "empresa.tamanhoQr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "xAss",
      "label": "Pos X QRCode"
    },
    model: {
      value: (_vm.empresa.xQr),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "xQr", $$v)
      },
      expression: "empresa.xQr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "yQr",
      "label": "Pos Y QRCode"
    },
    model: {
      value: (_vm.empresa.yQr),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "yQr", $$v)
      },
      expression: "empresa.yQr"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.empresa.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "tamanhoFont",
      "label": "Tamanho Fonte Assinatura"
    },
    model: {
      value: (_vm.empresa.tamanhoFont),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "tamanhoFont", $$v)
      },
      expression: "empresa.tamanhoFont"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "xAss",
      "label": "Pos X Assinatura"
    },
    model: {
      value: (_vm.empresa.xAss),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "xAss", $$v)
      },
      expression: "empresa.xAss"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "yAss",
      "label": "Pos Y Assinatura"
    },
    model: {
      value: (_vm.empresa.yAss),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "yAss", $$v)
      },
      expression: "empresa.yAss"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTemplate = true
      }
    }
  }, [_vm._v("Template Cartão de Acesso")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogTemplate),
      callback: function($$v) {
        _vm.dialogTemplate = $$v
      },
      expression: "dialogTemplate"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTemplate = false
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Template Cartão de Acesso")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "id": "iframeContext"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empresa.templateCartao),
      expression: "empresa.templateCartao"
    }],
    staticClass: "template",
    domProps: {
      "value": (_vm.empresa.templateCartao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empresa, "templateCartao", $event.target.value)
      }
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cc75f6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmpresaForm.vue
// module id = 374
// module chunks = 1